var consent = function($) {
    function init() {
        var $cookieConsent = $('.cookie-consent');

        if (document.cookie.match(/cookie-consent=1/) === null) {
            $cookieConsent.removeClass('d-none');
        }
        $cookieConsent.find('.show-info').click(function() {
            $(this).hide();
            $cookieConsent.find('.info').show(400);
        });
        $cookieConsent.find('button').click(function() {
            document.cookie = 'cookie-consent=1;path=/';
            $cookieConsent.toggleClass('d-none', true);
        });
    }

    init();
};

module.exports = {
    consent,
};

